/*
  Request methods
*/

export const DELETE = 'delete';
export const GET = 'get';
export const PATCH = 'patch';
export const POST = 'post';
export const PUT = 'put';
